export default __webpack_public_path__ + "static/media/icon-social-like.643ee88f.svg";